export function getSmallImageUrl(url: string, size: number): string {
    if (!url.includes("cloudinary")) {
        return url;
    }

    const enlargedSize = size * 2;
    const [start, end] = url.split("upload");
    return `${start}upload/c_fill,w_${enlargedSize},h_${enlargedSize},q_100${end}`;
}